import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  BalanceAdjustmentLiteModel,
  BalanceAdjustmentModel,
  getBalanceAdjustmentInput,
  getBalanceAdjustmentsInput,
} from './model';

export function useGetBalanceAdjustments(
  input?: getBalanceAdjustmentsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<BalanceAdjustmentLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<BalanceAdjustmentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getBalanceAdjustments', input?.params],
      () =>
        QueryFetchFunction({
          url: `balance-adjustments`,
          params: input?.params,
        }),
      options,
    ),
    BalanceAdjustmentLiteModel,
  );
}

export function useGetBalanceAdjustment(
  input?: getBalanceAdjustmentInput,
  options?: UseQueryOptions<ApiResult<BalanceAdjustmentModel>, ApiError>,
): UseQueryResult<ApiResult<BalanceAdjustmentModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getBalanceAdjustment', input?.id],
      () =>
        QueryFetchFunction({
          url: `balance-adjustments/${input?.id}`,
        }),
      options,
    ),
    BalanceAdjustmentModel,
  );
}

export function getBalanceAdjustmentsKey(input?: getBalanceAdjustmentsInput) {
  return ['getBalanceAdjustments', input?.params];
}

export function getBalanceAdjustmentKey(input?: getBalanceAdjustmentInput) {
  return ['getBalanceAdjustment', input?.id];
}
